'use client';

import React from 'react';
import { TeamGridBlock as ITeamGridBlock } from '../types';
import Image from 'next/image';
import LinkedInIcon from '@/assets/linkedin.svg';
import { SupportedLanguages } from '@/types/globals';

export default function TeamGridBlock({
  block,
  locale,
}: {
  block: ITeamGridBlock;
  locale: SupportedLanguages;
}) {
  const isEnglish = locale === 'en';
  const members = Array.isArray(block.team_members) ? block.team_members : [];

  return (
    <div className="mx-auto max-w-7xl py-8">
      {block.title && (
        <div className="items-left flex px-5">
          <span className="font-source-serif-pro text-[24px] leading-[120%] font-semibold tracking-[-0.014em] whitespace-nowrap text-teal-700">
            {block.title}
          </span>
          <div className="bg-graphite-100 mt-4 ml-8 h-px flex-1" />
        </div>
      )}
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {members &&
          members.map((member, idx) => (
            <div key={idx} className="rounded-lg p-4 sm:p-5">
              <div className="mb-4">
                <div className="rounded-lg" style={{ width: 350, height: 350 }}>
                  {member.profile_picture && member.profile_picture.url && (
                    <Image
                      src={member.profile_picture.url}
                      alt={member.profile_picture.alt || member.title}
                      className="h-full w-full rounded-lg object-cover"
                      width={350}
                      height={350}
                    />
                  )}
                </div>
              </div>
              <h3 className="font-source-serif-pro text-graphite-900 mb-1 text-[20px] leading-[130%] font-normal tracking-[-0.014em]">
                {member.title}
              </h3>
              <p className="font-source-sans-pro text-qf-purple mb-3 text-[14px] leading-[24px] font-semibold tracking-[0.10em] uppercase">
                {isEnglish ? member.position : member.fr_position || ''}
              </p>
              {member.linkedin_url && (
                <button
                  onClick={() => window.open(member.linkedin_url, '_blank')}
                >
                  <LinkedInIcon />
                </button>
              )}
            </div>
          ))}
      </div>
    </div>
  );
}
